import classNames from "classnames";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { useWindowDimensions } from "../WindowDimensionsProvider";
import "./style.css";
import womanExclamation from "./womanExclamation.svg";

const fm = getFormattedMessageWithScope("components.ResizeWrapper");

interface ResizeWrapperProps {
    children: any;
}

export const ResizeWrapper = ({ children }: ResizeWrapperProps) => {
    const { height } = useWindowDimensions();

    return (
        <div>
            <div
                className={
                    height > 500
                        ? "c-ResizeWrapper-visible"
                        : "c-ResizeWrapper-not-visible"
                }
            >
                {children}
            </div>
            <div
                className={classNames(
                    "c-ResizeWrapper-resize-container",
                    height < 500
                        ? "c-ResizeWrapper-resize-container-visible"
                        : "c-ResizeWrapper-resize-container-not-visible"
                )}
            >
                <div className="c-ResizeWrapper-resize-content">
                    <img
                        alt="woman"
                        src={womanExclamation}
                        className="c-ResizeWrapper-resize-woman-image"
                    />
                    <p className="c-ResizeWrapper-resize-message">
                        {fm("resizeScreenOrChangeOrientation")}
                    </p>
                </div>
            </div>
        </div>
    );
};
